import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { trackPageView, setUserProperties } from '@/lib/analytics';

export function AnalyticsProvider() {
  const location = useLocation();
  const { user, profile, isAdmin } = useAuth();
  const prevPath = useRef(location.pathname);

  // Track route changes
  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      trackPageView(location.pathname + location.search);
      prevPath.current = location.pathname;
    }
  }, [location]);

  // Set user properties when auth state changes
  useEffect(() => {
    if (user && profile) {
      setUserProperties({
        user_id: user.id,
        membership_plan: profile.membership_plan,
        membership_status: profile.membership_status,
        is_admin: isAdmin,
      });
    } else if (!user) {
      setUserProperties({
        user_id: undefined,
        membership_plan: undefined,
        membership_status: undefined,
        is_admin: false,
      });
    }
  }, [user, profile, isAdmin]);

  return null;
}
